"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("motion/react");
const DEFAULT_DURATION = 0.15;
const Appear = ({ children, duration = DEFAULT_DURATION, }) => {
    if ((0, react_1.useReducedMotionConfig)()) {
        return (0, jsx_runtime_1.jsx)("div", { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(react_1.motion.div, { initial: { scale: 0 }, animate: { scale: 1 }, transition: { duration }, children: children }));
};
exports.default = Appear;
